module.exports = __webpack_public_path__ + "static/media/braintree.2fac19f2.png";